//app 建立 chat
export const IR_CREATE = 'create'

//windows app 與 app 連線配對
export const IR_GAMEMAPPING = 'gamemapping';

//windows app 向 app 傳送資料
export const IR_DATAPUSHING = 'datapushing';
